import _ from 'lodash';

function constructPricesMap(departStops, destinationStops, prices, stops, priceOverride = null){

    let combinationOfStops = []
    let price = null;
        departStops.forEach((departStop)=>{
        destinationStops.forEach((destinationStop)=>{

          let departStopValue = _.find(stops, {id: departStop.stop})
          let destinationStopValue = _.find(stops, {id: destinationStop.stop})
          if(prices && prices.length && departStopValue && destinationStopValue){
             price = _.find(prices, {from_stop_id: departStop.stop, to_stop_id: destinationStop.stop})
          }
          if(departStopValue && destinationStopValue){
            combinationOfStops.push({
                departStop: {...departStop, address: departStopValue.address}, 
                destinationStop: {...destinationStop, address: destinationStopValue.address},
                price: price && price.price || '',
                customRouteId: price && price.id,
                priceOverride

            })
          }
        })
    })

    return combinationOfStops;
}


// Turns whatever the API rejected with into a sentence we can show an admin.
// The backend sends plain strings for validation errors but a {message, code} object for
// payment declines, and fetch hands both back as raw text — so an unparsed object used to
// fall through to a generic message (or render as nothing at all).
function serverErrorMessage(err, fallback) {
    let raw = err;
    if (raw && typeof raw === 'object') {
        raw = (raw.response && raw.response.data) || raw.message || raw.error || '';
    }
    if (typeof raw !== 'string') return fallback;
    const text = raw.trim();
    if (!text) return fallback;
    if (text.charAt(0) === '{' || text.charAt(0) === '[') {
        try {
            const parsed = JSON.parse(text);
            const message = parsed.message || parsed.error
                || (Array.isArray(parsed) && parsed[0] && (parsed[0].message || parsed[0]));
            if (message && typeof message === 'string') return message;
        } catch (e) { /* not JSON after all — fall through */ }
    }
    if (text.charAt(0) === '<') return fallback; // server returned an HTML error page
    return text;
}

export {constructPricesMap, serverErrorMessage}